/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';

const useSources = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.SOURCES,
    queryFn: async () => API.getInstance().getSources().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const sourcesOptions = React.useMemo(
    () => data?.map((option) => ({ label: option, value: option })) || [],
    [data],
  );

  return {
    sourcesLoading: isLoading,
    sourcesOptions,
    data,
    error,
    fetchSources: refetch,
  };
};

export {
  useSources,
};
